import React from 'react'
import PropTypes from 'prop-types'
import Author from '../Author'
import AuthorInfo from './AuthorInfo'
import ShareIcons from '../ShareIcons'
import RichText from '../RichText'
import styles from './index.module.scss'
import PostImage from './PostImage'

const PostLayout = ({ post }) => {
  return (
    <div data-testid="post-layout">
      <div className="my-6" data-testid="header">
        <h1
          data-testid="post-title"
          className="mt-4 text-4xl leading-10 text-blue-700"
        >
          {post.title}
        </h1>
      </div>
      {post.author && (
        <Author
          title={post.author.fullName}
          date={new Date(post.updatedAt)}
          jobPosition={post.author.jobTitle}
          img={post.author.avatar}
          url={`/author/${post.author.slug}/`}
        />
      )}

      <PostImage image={post.imageAsset} title={post.title} />
      <ShareIcons className="mt-4 md:mt-6" title={post.title} />
      <RichText
        key={post.slug}
        contentData={post.content}
        className={styles.richText}
      />
      {post.author && <AuthorInfo author={post.author} />}
    </div>
  )
}

PostLayout.defaultProps = {
  post: {
    slug: '',
    image: '',
    category: {},
    content: {},
  },
}

PostLayout.propTypes = {
  post: PropTypes.object,
  type: PropTypes.string.isRequired,
}

export default PostLayout
